import { Coffee, Instagram, MapPin, Phone } from "lucide-react";
import { CAFE, NAV_LINKS } from "../data/cafeData";

export const Footer = () => (
  <footer data-testid="site-footer" className="grain-overlay bg-[#21150C] pb-10 pt-20 text-[#FDFBF7]">
    <div className="relative z-10 mx-auto max-w-6xl px-5 md:px-8">
      <div className="grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#C86D51] text-[#FDFBF7]">
              <Coffee size={18} />
            </span>
            <span className="font-serif text-3xl font-bold tracking-tight">Nomad Cafe</span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#FDFBF7]/65">
            A nomadic sanctuary for craft coffee in northwest Calgary.
            Come wander in — the kettle's always on.
          </p>
          <a
            href={CAFE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#FDFBF7]/25 px-5 py-2.5 font-accent text-xs font-semibold uppercase tracking-wider text-[#FDFBF7]/85 transition-colors hover:border-[#C86D51] hover:text-[#E8A08A]"
          >
            <Instagram size={14} /> {CAFE.instagramHandle}
          </a>
        </div>

        <div>
          <h3 className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#D49B4B]">Explore</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={`footer-${link.testid}`}
                  className="text-sm text-[#FDFBF7]/70 transition-colors hover:text-[#E8A08A]"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <span data-testid="footer-order-link" className="text-sm text-[#FDFBF7]/40">
                Order Online — Coming Soon
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#D49B4B]">Visit</h3>
          <ul className="mt-5 space-y-4 text-sm text-[#FDFBF7]/70">
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="mt-0.5 shrink-0 text-[#C86D51]" />
              <span>{CAFE.address}<br />{CAFE.addressCity}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={15} className="shrink-0 text-[#C86D51]" />
              <a href={CAFE.phoneHref} data-testid="footer-phone-link" className="transition-colors hover:text-[#E8A08A]">
                {CAFE.phone}
              </a>
            </li>
            <li className="text-xs leading-relaxed text-[#FDFBF7]/50">
              Mon–Thu 8 AM – 9 PM<br />
              Fri 8 AM – 10 PM<br />
              Sat 10 AM – 10 PM · Sun 10 AM – 6 PM
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-[#FDFBF7]/10 pt-8 text-xs text-[#FDFBF7]/45 md:flex-row">
        <p>© 2026 Nomad Cafe YYC. All rights reserved.</p>
        <p className="font-serif italic">Brewed with love in Calgary, Alberta.</p>
      </div>
    </div>
  </footer>
);
